<div class="detalhe-requerimento">
  @if (naoEncontrada()) {
    <div class="detalhe-requerimento__empty" role="alert" data-testid="detalhe-requerimento-nao-encontrada">
      <p class="detalhe-requerimento__empty-message">Solicitação não encontrada.</p>
      <vivest-button variant="primary" size="md" data-testid="sem-dados-voltar" (click)="voltar()">
        Voltar
      </vivest-button>
    </div>
  } @else if (solicitacao(); as solicitacao) {
    <!-- Título com o status ao lado e, embaixo, o resumo da solicitação; ações da integração e Voltar à direita. -->
    <header class="detalhe-requerimento__header">
      <div class="detalhe-requerimento__titulo-bloco">
        <div class="detalhe-requerimento__titulo-linha">
          <h1 id="detalhe-requerimento-title" class="detalhe-requerimento__title" data-testid="detalhe-requerimento-nome">
            Detalhes do participante
          </h1>
          <app-requerimento-status-tag [status]="solicitacao.status" data-testid="detalhe-requerimento-status" />
        </div>
        <p class="detalhe-requerimento__resumo" data-testid="detalhe-requerimento-resumo">
          <span>Protocolo nº {{ solicitacao.protocolo }}</span>
          @if (solicitacao.ultimaAtualizacao) {
            <span>Última atualização em {{ dataHora(solicitacao.ultimaAtualizacao) }}</span>
          }
        </p>
      </div>
      <div class="detalhe-requerimento__header-acoes">
        <!-- Ações da integração com o corporativo, pelas flags da API (PRE-332). -->
        @if (podeRegistrarErro()) {
          <vivest-button variant="outline" size="md" data-testid="detalhe-requerimento-registrar-erro" (click)="abrirRegistrarErro()">
            Registrar erro
          </vivest-button>
        }
        @if (podeConcluir()) {
          <vivest-button variant="primary" size="md" data-testid="detalhe-requerimento-concluir" (click)="abrirConcluir()">
            Aprovar solicitação
          </vivest-button>
        }
        @if (podeReprocessar()) {
          <vivest-button variant="primary" size="md" data-testid="detalhe-requerimento-reprocessar" (click)="abrirReprocessar()">
            Reprocessar
          </vivest-button>
        }
        <vivest-button variant="outline" size="md" data-testid="detalhe-requerimento-voltar" (click)="voltar()">
          <vivest-icon slot="icon-left" name="arrow-left" source="feather"></vivest-icon>
          Voltar
        </vivest-button>
      </div>
    </header>

    <!-- Erro ao processar requisição: o motivo devolvido pelo corporativo (ou registrado pelo operador). -->
    @if (solicitacao.motivoErroIntegracao) {
      <div class="detalhe-requerimento__erro" role="alert" data-testid="detalhe-requerimento-erro-integracao">
        <vivest-icon name="alert-triangle" source="feather" aria-hidden="true"></vivest-icon>
        <div>
          <p class="detalhe-requerimento__erro-titulo">Erro ao processar a requisição</p>
          <p class="detalhe-requerimento__erro-motivo">{{ solicitacao.motivoErroIntegracao }}</p>
          <p class="detalhe-requerimento__erro-dica">Confira no corporativo e reprocesse a solicitação.</p>
        </div>
      </div>
    }

    <!-- Dados e documentos à esquerda; histórico à direita (empilham em telas estreitas). -->
    <div class="detalhe-requerimento__conteudo">
      <div class="detalhe-requerimento__principal">
        <section aria-labelledby="dados-titulo">
          <vivest-card variant="default" full-width data-testid="detalhes-painel">
            <div class="detalhe-requerimento__card">
              <h2 id="dados-titulo" class="page-section-title">Dados da solicitação</h2>
              <dl class="detalhe-requerimento__fields">
                <div class="detalhe-requerimento__field detalhe-requerimento__field--inteiro">
                  <dt class="detalhe-requerimento__label">Participante</dt>
                  <dd class="detalhe-requerimento__value detalhe-requerimento__value--destaque">{{ solicitacao.nomeParticipante || '—' }}</dd>
                </div>
                <div class="detalhe-requerimento__field">
                  <dt class="detalhe-requerimento__label">Matrícula</dt>
                  <dd class="detalhe-requerimento__value" data-testid="detalhe-requerimento-matricula">
                    {{ solicitacao.matricula }}
                  </dd>
                </div>
                <div class="detalhe-requerimento__field">
                  <dt class="detalhe-requerimento__label">Nº Protocolo de Solicitação</dt>
                  <dd class="detalhe-requerimento__value" data-testid="detalhe-requerimento-protocolo">
                    {{ solicitacao.protocolo }}
                  </dd>
                </div>
                <div class="detalhe-requerimento__field">
                  <dt class="detalhe-requerimento__label">Plano</dt>
                  <dd class="detalhe-requerimento__value" data-testid="detalhe-requerimento-plano">
                    {{ solicitacao.plano || '—' }}
                  </dd>
                </div>
                <div class="detalhe-requerimento__field">
                  <dt class="detalhe-requerimento__label">Tipo de benefício</dt>
                  <dd class="detalhe-requerimento__value" data-testid="detalhe-requerimento-tipo-beneficio">
                    {{ solicitacao.tipoBeneficio || '—' }}
                  </dd>
                </div>
                <div class="detalhe-requerimento__field">
                  <dt class="detalhe-requerimento__label">Data e hora da Solicitação</dt>
                  <dd class="detalhe-requerimento__value" data-testid="detalhe-requerimento-data">
                    {{ solicitacao.dataSolicitacao ? dataHora(solicitacao.dataSolicitacao) : '—' }}
                  </dd>
                </div>
                <!-- Só requerimentos cancelados: o cancelamento não gera protocolo na base, então vão a data e o motivo. -->
                @if (solicitacao.dataCancelamento) {
                  <div class="detalhe-requerimento__field">
                    <dt class="detalhe-requerimento__label">Cancelado em</dt>
                    <dd class="detalhe-requerimento__value" data-testid="detalhe-requerimento-cancelamento">
                      {{ dataHora(solicitacao.dataCancelamento) }}
                    </dd>
                  </div>
                  <div class="detalhe-requerimento__field">
                    <dt class="detalhe-requerimento__label">Motivo do cancelamento</dt>
                    <dd class="detalhe-requerimento__value" data-testid="detalhe-requerimento-motivo-cancelamento">
                      {{ solicitacao.motivoCancelamento || '—' }}
                    </dd>
                  </div>
                }
              </dl>
            </div>
          </vivest-card>
        </section>

        <section aria-labelledby="documentacao-titulo">
          <vivest-card variant="default" full-width data-testid="documentos-painel">
            <div class="documentos">
              <h2 id="documentacao-titulo" class="page-section-title">
                Documentação anexada
                @if (documentos().length > 0) {
                  <span class="documentos__contagem" data-testid="documentos-contagem">{{ documentos().length }}</span>
                }
              </h2>

              @if (semDocumento()) {
                <p class="documentos__vazio" data-testid="documentos-vazio">
                  Não há documentação anexada pelo participante neste momento do processo.
                </p>
              } @else {
                <!-- Cada documento baixa o arquivo enviado pelo participante. -->
                <ul class="documentos__lista">
                  @for (documento of documentos(); track documento.idDocumento) {
                    <!-- O cartão inteiro baixa o arquivo; o olho, por cima do cartão, abre o arquivo no modal. -->
                    <li
                      class="documentos__item"
                      [class.documentos__item--reenviado]="reenviado(documento)"
                      [class.documentos__item--rejeitado]="rejeitado(documento)"
                      [class.documentos__item--validado]="validado(documento)"
                      [attr.data-testid]="reenviado(documento) ? 'documento-reenviado' : rejeitado(documento) ? 'documento-rejeitado' : validado(documento) ? 'documento-validado' : null"
                    >
                      <button
                        type="button"
                        class="documentos__arquivo"
                        [attr.aria-label]="'Baixar ' + documento.tipoDocumento + ' (' + documento.nomeArquivo + ')'"
                        data-testid="documento-link"
                        (click)="baixar(documento)"
                      >
                        <img class="documentos__icone" src="assets/images/Documento.svg" alt="" />
                        <span class="documentos__info">
                          <span class="documentos__tipo">
                            {{ documento.tipoDocumento }}
                            @if (reenviado(documento)) {
                              <span class="documentos__selo">Reenviado para análise</span>
                            } @else if (rejeitado(documento)) {
                              <span class="documentos__selo documentos__selo--rejeitado">Rejeitado</span>
                            } @else if (validado(documento)) {
                              <span class="documentos__selo documentos__selo--validado">Validado</span>
                            }
                          </span>
                          <span class="documentos__nome">{{ documento.nomeArquivo }}</span>
                          @if (reenviado(documento)) {
                            <span class="documentos__reenvio">Reenviado em {{ dataHora(documento.enviadoEm) }}</span>
                            @if (documento.recusaAnterior?.motivo) {
                              <span class="documentos__motivo" data-testid="documento-recusa-anterior">
                                Recusa anterior: {{ documento.recusaAnterior?.motivo }}
                              </span>
                            }
                          } @else if (rejeitado(documento)) {
                            <span class="documentos__reenvio documentos__reenvio--rejeitado">
                              @if (documento.analisadoEm) {
                                Rejeitado em {{ dataHora(documento.analisadoEm) }} · aguardando reenvio do participante
                              } @else {
                                Aguardando reenvio do participante
                              }
                            </span>
                            <span class="documentos__motivo" data-testid="documento-motivo">Motivo: {{ documento.motivoRecusa }}</span>
                          } @else {
                            <span class="documentos__dica">Clique para baixar o documento</span>
                          }
                        </span>
                        <vivest-icon class="documentos__download" name="download" source="feather" aria-hidden="true"></vivest-icon>
                      </button>
                      <button
                        type="button"
                        class="documentos__visualizar"
                        title="Visualizar documento"
                        [attr.aria-label]="'Visualizar ' + documento.tipoDocumento + ' (' + documento.nomeArquivo + ')'"
                        data-testid="documento-visualizar"
                        (click)="abrirVisualizacao(documento)"
                      >
                        <vivest-icon name="eye" source="feather" aria-hidden="true"></vivest-icon>
                      </button>
                    </li>
                  }
                </ul>
              }

              <!-- Aviso em destaque em "Solicitado" e "Documento reenviado" (também sem documento): orientação à esquerda, ações à direita. -->
              @if (podeValidarDocumentos()) {
                <div class="documentos__acao" role="group" aria-labelledby="documentos-acao-titulo">
                  <div class="documentos__acao-texto">
                    <h3 id="documentos-acao-titulo" class="documentos__acao-titulo">
                      <vivest-icon name="alert-circle" source="feather" aria-hidden="true"></vivest-icon>
                      Ação necessária
                    </h3>
                    <p class="documentos__acao-descricao" data-testid="documentos-acao-descricao">
                      @if (semDocumento()) {
                        O participante não enviou documentos. Aprove para seguir com a solicitação.
                      } @else if (documentosReenviados().length) {
                        O participante reenviou <strong>{{ nomesReenviados() }}</strong>. Confira o que foi reenviado: aprove se
                        estiver correto ou peça o reenvio de novo.
                      } @else if (documentoUnico()) {
                        Confira o documento enviado pelo participante. Aprove se estiver correto ou peça o reenvio.
                      } @else {
                        Confira os documentos enviados pelo participante. Aprove se estiverem corretos ou peça o reenvio dos que tiverem problema.
                      }
                    </p>
                  </div>
                  <div class="documentos__botoes">
                    @if (pendentes().length > 0) {
                      <vivest-button variant="outline" size="md" data-testid="documentos-reenvio" (click)="abrirReenvio()">
                        {{ documentoUnico() ? 'Solicitar reenvio do documento' : 'Solicitar reenvio de documentos' }}
                      </vivest-button>
                    }
                    <vivest-button variant="primary" size="md" data-testid="documentos-aprovar" (click)="abrirConfirmacao()">
                      {{ semDocumento() ? 'Aprovar' : documentoUnico() ? 'Aprovar Documento' : 'Aprovar Documentos' }}
                    </vivest-button>
                  </div>
                </div>
              }
            </div>
          </vivest-card>
        </section>
      </div>

      <section class="detalhe-requerimento__lateral" aria-labelledby="historico-titulo">
        <vivest-card variant="default" full-width data-testid="historico-painel">
          <div class="historico">
            <h2 id="historico-titulo" class="page-section-title">Histórico da solicitação</h2>
            @if (historico().length === 0) {
              <p class="historico__vazio" data-testid="historico-vazio">Nenhuma movimentação registrada.</p>
            } @else {
              <!-- Mais recente primeiro: cada item é uma mudança de status. -->
              <ol class="historico__lista">
                @for (item of historico(); track item.idHistorico) {
                  <li class="historico__item" data-testid="historico-item">
                    <span class="historico__marcador" aria-hidden="true"></span>
                    <div class="historico__conteudo">
                      <app-requerimento-status-tag [status]="item.statusNovo" />
                      <p class="historico__meta">
                        <span>{{ dataHora(item.alteradoEm) }}</span>
                        <span>por {{ item.origem }}</span>
                      </p>
                      @if (item.statusAnterior) {
                        <p class="historico__anterior">Status anterior: {{ item.statusAnterior }}</p>
                      }
                      @if (item.observacao) {
                        <p class="historico__observacao">{{ item.observacao }}</p>
                      }
                    </div>
                  </li>
                }
              </ol>
            }
          </div>
        </vivest-card>
      </section>
    </div>
  }
</div>

<vivest-modal
  heading="Você tem certeza?"
  [hasIcon]="false"
  [open]="confirmacaoAberta()"
  position="center"
  (vivest-close)="fecharConfirmacao()"
  data-testid="modal-aprovar"
>
  <!-- O vivest-modal só exibe conteúdo nos slots icon, heading, description e actions. -->
  <div slot="description">
    <p class="mb-0 text-start">
      Você tem certeza que deseja aprovar esse requerimento? Em seguida, a solicitação é enviada para processamento.
    </p>
  </div>
  <vivest-button slot="actions" variant="outline" size="md" data-testid="modal-aprovar-cancelar" (click)="fecharConfirmacao()">
    Cancelar
  </vivest-button>
  <vivest-button slot="actions" variant="primary" size="md" data-testid="modal-aprovar-confirmar" (click)="aprovar()">
    Aprovar
  </vivest-button>
</vivest-modal>

<vivest-modal
  [heading]="documentoUnico() ? 'Solicitar reenvio do documento' : 'Solicitar reenvio de documentos'"
  [hasIcon]="false"
  [open]="reenvioAberto()"
  position="center"
  (vivest-close)="fecharReenvio()"
  data-testid="modal-reenvio"
>
  <form slot="description" class="reenvio" novalidate [formGroup]="reenvioForm" (submit)="$event.preventDefault(); enviarReenvio()">
    <p class="reenvio__texto">
      Marque os documentos que o participante precisa reenviar e informe o motivo de cada um. Os demais serão aprovados.
    </p>

    <fieldset class="reenvio__documentos" formArrayName="documentos">
      <legend class="campanha-form-label">Documentos<span class="campanha-form-required" aria-hidden="true">*</span></legend>
      @for (grupo of reenvioDocumentos.controls; track grupo.controls.idDocumento.value; let indice = $index) {
        <div class="reenvio__documento" [formGroupName]="indice">
          <vivest-checkbox
            label-variant="multi-line"
            name="documentos-reenvio"
            [value]="grupo.controls.idDocumento.value"
            [checked]="grupo.controls.marcado.value"
            (change)="alternarDocumento(indice, $any($event.target).checked)"
            [attr.data-testid]="'reenvio-documento-' + indice"
          >
            {{ tipoDocumento(grupo.controls.idDocumento.value) }}
          </vivest-checkbox>
          @if (grupo.controls.marcado.value) {
            <div class="reenvio__comentario">
              <label class="campanha-form-label" [for]="'reenvio-motivo-' + indice">
                Motivo<span class="campanha-form-required" aria-hidden="true">*</span>
              </label>
              <textarea
                [id]="'reenvio-motivo-' + indice"
                class="form-control campanha-form-control campanha-form-textarea"
                rows="2"
                placeholder="O participante verá este motivo"
                [attr.maxlength]="motivoMaximo"
                formControlName="motivo"
                [class.is-invalid]="!!erroMotivo(indice)"
                [attr.data-testid]="'reenvio-motivo-' + indice"
              ></textarea>
              <p class="reenvio__contador">{{ grupo.controls.motivo.value.length }}/{{ motivoMaximo }}</p>
              @if (erroMotivo(indice); as mensagem) {
                <p class="campanha-form-error" role="alert" [attr.data-testid]="'reenvio-motivo-erro-' + indice">{{ mensagem }}</p>
              }
            </div>
          }
        </div>
      }
      @if (reenvioForm.touched && nenhumMarcado()) {
        <p class="campanha-form-error" role="alert" data-testid="reenvio-documentos-erro">
          Selecione ao menos um documento.
        </p>
      }
    </fieldset>
  </form>
  <vivest-button slot="actions" variant="outline" size="md" data-testid="modal-reenvio-cancelar" (click)="fecharReenvio()">
    Cancelar
  </vivest-button>
  <vivest-button slot="actions" variant="primary" size="md" data-testid="modal-reenvio-enviar" (click)="enviarReenvio()">
    Enviar para o participante
  </vivest-button>
</vivest-modal>

<vivest-modal
  heading="Aprovar solicitação"
  [hasIcon]="false"
  [open]="concluirAberto()"
  position="center"
  (vivest-close)="fecharConcluir()"
  data-testid="modal-concluir"
>
  <div slot="description">
    <p class="mb-0 text-start">Confirma que o processo foi concluído no corporativo? A solicitação passa a "Concluído".</p>
  </div>
  <vivest-button slot="actions" variant="outline" size="md" data-testid="modal-concluir-cancelar" (click)="fecharConcluir()">
    Cancelar
  </vivest-button>
  <vivest-button slot="actions" variant="primary" size="md" data-testid="modal-concluir-confirmar" (click)="concluir()">
    Aprovar solicitação
  </vivest-button>
</vivest-modal>

<vivest-modal
  heading="Registrar erro"
  [hasIcon]="false"
  [open]="erroIntegracaoAberto()"
  position="center"
  (vivest-close)="fecharRegistrarErro()"
  data-testid="modal-registrar-erro"
>
  <form slot="description" class="reenvio" novalidate [formGroup]="erroIntegracaoForm" (submit)="$event.preventDefault(); registrarErro()">
    <p class="reenvio__texto">Informe o erro apontado pelo corporativo. A solicitação passa a "Erro ao processar requisição".</p>
    <div class="reenvio__comentario">
      <label class="campanha-form-label" for="erro-integracao-motivo">
        Motivo<span class="campanha-form-required" aria-hidden="true">*</span>
      </label>
      <textarea
        id="erro-integracao-motivo"
        class="form-control campanha-form-control campanha-form-textarea"
        rows="3"
        [attr.maxlength]="motivoMaximo"
        formControlName="motivo"
        [class.is-invalid]="!!erroMotivoIntegracao()"
        data-testid="registrar-erro-motivo"
      ></textarea>
      <p class="reenvio__contador">{{ erroIntegracaoForm.controls.motivo.value.length }}/{{ motivoMaximo }}</p>
      @if (erroMotivoIntegracao(); as mensagem) {
        <p class="campanha-form-error" role="alert" data-testid="registrar-erro-motivo-erro">{{ mensagem }}</p>
      }
    </div>
  </form>
  <vivest-button slot="actions" variant="outline" size="md" data-testid="modal-registrar-erro-cancelar" (click)="fecharRegistrarErro()">
    Cancelar
  </vivest-button>
  <vivest-button slot="actions" variant="primary" size="md" data-testid="modal-registrar-erro-confirmar" (click)="registrarErro()">
    Registrar erro
  </vivest-button>
</vivest-modal>

<vivest-modal
  heading="Reprocessar"
  [hasIcon]="false"
  [open]="reprocessarAberto()"
  position="center"
  (vivest-close)="fecharReprocessar()"
  data-testid="modal-reprocessar"
>
  <div slot="description">
    <p class="mb-0 text-start">Enviar a solicitação novamente ao corporativo?</p>
  </div>
  <vivest-button slot="actions" variant="outline" size="md" data-testid="modal-reprocessar-cancelar" (click)="fecharReprocessar()">
    Cancelar
  </vivest-button>
  <vivest-button slot="actions" variant="primary" size="md" data-testid="modal-reprocessar-confirmar" (click)="reprocessar()">
    Reprocessar
  </vivest-button>
</vivest-modal>

<!-- O iframe só existe com o modal aberto: o arquivo só é carregado quando o analista pede. -->
<vivest-modal
  class="visualizador-modal"
  style="--vivest-modal-width: 951px;"
  [heading]="documentoVisualizado()?.tipoDocumento ?? ''"
  [hasIcon]="false"
  [open]="!!documentoVisualizado()"
  position="center"
  (vivest-close)="fecharVisualizacao()"
  data-testid="modal-visualizar-documento"
>
  @if (documentoVisualizado(); as documento) {
    <div slot="description" class="visualizador">
      <!-- Arquivo à esquerda; abrir fora do modal e baixar à direita, sem precisar fechar. -->
      <div class="visualizador__barra">
        <span class="visualizador__arquivo">
          <img class="visualizador__icone" src="assets/images/Documento.svg" alt="" />
          <span class="visualizador__nome" data-testid="visualizador-nome">{{ documento.nomeArquivo }}</span>
        </span>
        <span class="visualizador__acoes">
          <a
            class="visualizador__acao"
            [href]="urlArquivo()"
            target="_blank"
            rel="noopener"
            data-testid="visualizador-nova-aba"
          >
            <vivest-icon name="external-link" source="feather" aria-hidden="true"></vivest-icon>
            Abrir em nova aba
          </a>
          <button type="button" class="visualizador__acao" data-testid="visualizador-baixar" (click)="baixarVisualizado()">
            <vivest-icon name="download" source="feather" aria-hidden="true"></vivest-icon>
            Baixar
          </button>
        </span>
      </div>
      <iframe
        class="visualizador__pdf"
        [src]="urlVisualizacao()"
        [title]="'Visualização de ' + documento.tipoDocumento"
        data-testid="visualizador-pdf"
      ></iframe>
    </div>
  }
  <vivest-button slot="actions" variant="primary" size="md" data-testid="modal-visualizar-fechar" (click)="fecharVisualizacao()">
    Fechar
  </vivest-button>
</vivest-modal>
